module.exports = __webpack_public_path__ + "img/android.41c8571e.png";